"use strict";

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  bottom: ", ";\n  right: ", ";\n  top: 0;\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n  justify-content: flex-end;\n  pointer-events: none;\n  margin: 0 !important;\n  z-index: ", ";\n  li {\n    pointer-events: all;\n    &:not(:last-child) {\n      margin-bottom: ", ";\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notifications = void 0;

var framer_motion_1 = require("framer-motion");

var react_1 = __importDefault(require("react"));

var styledTypes_1 = require("../styledTypes");

var zIndex_1 = require("../zIndex");

function Notifications(_ref) {
  var notifications = _ref.notifications;
  return react_1["default"].createElement(Container, null, react_1["default"].createElement(framer_motion_1.AnimatePresence, {
    initial: false
  }, notifications.map(function (_ref2) {
    var key = _ref2.key,
        children = _ref2.children;
    return react_1["default"].createElement(framer_motion_1.motion.li, {
      key: key,
      initial: {
        opacity: 0,
        y: 50,
        scale: 0.3
      },
      animate: {
        opacity: 1,
        y: 0,
        scale: 1
      },
      exit: {
        opacity: 0,
        scale: 0.5,
        transition: {
          duration: 0.2
        }
      }
    }, children);
  })));
}

exports.Notifications = Notifications;
var Container = styledTypes_1.styled.ul(_templateObject(), function (props) {
  return props.theme['@size-l'];
}, function (props) {
  return props.theme['@size-l'];
}, zIndex_1.ZIndex.Notifications, function (props) {
  return props.theme['@size-s'];
});